import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddProcessManagement.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";

// Points configuration for each question
const QUESTION_POINTS = {
  1.1: 10,
  "1.2a": 5,
  "1.2b": 5,
  "1.2c": 5,
  "1.2d": 5,
  "1.2e": 5,
  "1.2f": 5,
  "1.2g": 5,
  1.3: 10,
  1.4: 10,
  "1.5a": 5,
  "1.5b": 5,
  1.6: 10,
  1.7: 10,
  1.8: 10,
  1.9: 10,
  "1.10": 10,
};

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="3.1"
          title="Procedure and/or Process for Personnel Management"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Definition of the structure of the organization (organizational plan) based on the needs of the laboratory activities;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Definition of job profiles and job descriptions for all laboratory positions;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Selection and recruitment of appropriately qualified personnel;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Orientation of newly recruited and appointed personnel;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Establishment and maintenance of personnel records.",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          disabled={!editable}
          onAnswerChange={onAnswerChange}
          answers={answers}
        />

        <QuestionSection
          number="3.2"
          title="Duty Roster and Daily Routine"
          questions={[
            {
              content:
                "Does the laboratory have a duty roster that covers normal hours and after hours?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.3"
          title="Organizational Chart and External/Internal Reporting Systems"
          questions={[
            {
              content:
                "Is an organizational chart available for indicating the relationship between the laboratory and its parent organization?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.4"
          title="Laboratory Management"
          questions={[
            {
              content:
                "Is the laboratory directed by a person(s) (however named) with specified qualifications, authority, competency and delegated responsibility to perform the following:",
              hideOptions: true,
            },
            {
              content: "Provide effective leadership, budgeting and planning;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Communicate with stakeholders;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Ensure adequate competent personnel;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Ensure the implementation of the quality management system;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Select and monitor laboratory supplies;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Select and monitor referral laboratories;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Ensure a safe laboratory environment;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Provide advisory services;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Provide professional development programs for laboratory personnel;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Address complaints, requests, or suggestions from personnel and or laboratory users;",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Ensure the implementation and application of risk assessment program;",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Design and implement a contingency plan based on the risk assessment program;",
              number: "l",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Ensure management and operations of POCT activities.",
              number: "m",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.5"
          title="Compliance with Laboratory Management System"
          questions={[
            {
              content:
                "Is there a person or persons who, irrespective of other responsibilities, have the authority and resources needed to carry out their duties, including",
              hideOptions: true,
            },
            {
              content:
                "Implementation, maintenance, and improvement of the management system;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Identification of deviations from the management system or from the procedures for performing laboratory activities.",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.6"
          title="Procedure and/or Process for Authorization"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content: "List of activities that require authorization;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Defined criteria for authorizing persons for specific laboratory activities;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Documented authorization for the various activities;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Appointed deputies for the key positions where appropriate.",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.7"
          title="Authorization"
          questions={[
            {
              content:
                "Are personnel authorized to perform specific laboratory activities including, but not limited to, the following:",
              hideOptions: true,
            },
            {
              content:
                "Selection, development, modification, validation, and verification of methods;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Review, release, and reporting of results;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Use of laboratory information systems, particularly accessing patient data and information, entering patient data and examination results, and changing patient data or examination results.",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.8"
          title="Procedure and/or Process for Personnel Training"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content: "Identification of training needs;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Establishment of training program (including initial and refresher training);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Provision of a continuous education program;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Recording of training;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Evaluation of the effectiveness of the training program.",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.9"
          title="Laboratory Personnel Training, Continuing Education and Professional Development"
          questions={[
            {
              content:
                "Is there a program for training, continuing education and professional development including, but not limited to, the following:",
              hideOptions: true,
            },
            {
              content: "Laboratory management system;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Induction to the organization;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Assigned work processes, procedures, and tasks;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Applicable laboratory information system;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Health and safety, including the prevention or containment of the effects of adverse incidents;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Laboratory ethics, impartiality and confidentiality of patient information;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Supervision of persons undergoing training",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Continuous education (advancement in laboratory practice, clinical diagnostics, surveillance, etc.);",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Review of effectiveness of the training program",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="3.10"
          title="Procedure and/or Process for Competency Assessment"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or a process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Defining the methods of performing competency assessment;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Defining the competency requirements, criteria and frequency for each laboratory activity or function (managerial or technical tasks);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Assessment of ongoing competency;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Providing feedback (verbal, written, etc.) to persons assessed;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Scheduling retraining based on assessment outcomes;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Retention of records of competency assessments and outcomes",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="3.11"
          title="Implementation of Procedure and/or Process of Personnel Competency"
          questions={[
            {
              content:
                "Does the laboratory assess the competency of its personnel according to its defined criteria for all relevant activities including the following",
              hideOptions: true,
            },
            {
              content:
                "Records that indicate which skills were assessed, how those skills were measured, and who performed the assessment;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Competency assessments performed according to defined criteria for new hires and existing personnel;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Retraining and re-assessment where needed",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="3.12"
          title="Procedure and/or Process for Review of Personnel Performance"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Planning and performing personnel performance appraisals;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Establishing frequency of monitoring and reviewing of personnel performance outcome;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Keeping records of personnel performance",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="3.13"
          title="Personnel Meetings"
          questions={[
            {
              content:
                "Are personnel meetings held regularly and do they address the following meeting items?",
              hideOptions: true,
            },
            {
              content:
                "Follow-up of action items from previous personnel meetings;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Systemic and/or recurrent problems and issues addressed, including actions to prevent recurrence;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Complaints;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication on reviewed/revised/redundant SOPs and changes to the laboratory management system;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Review of results from prior to corrective actions;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Discussion and evaluation of improvement topics/projects;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Feedback given by personnel that have attended hospital meetings, clinical rounds, external meetings, training, conferences, workshops, etc.;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Provide advisory and/or interpretation of laboratory results and updates on laboratory attendance at meetings with clinicians (use of laboratory services);",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Recording, monitoring and follow-up of meeting actions;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Importance of meeting, needs and requirements of users and management system (ISO15189:2022)",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="3.14"
          title="Personnel Records"
          questions={[
            {
              content:
                "Are records of personnel maintained (hardcopy or electronic copy) and do they include the following?",
              hideOptions: true,
            },
            {
              content: "Educational and professional qualifications;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Determination of the competency requirements specified in Section 3 of this checklist;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Job descriptions in relation to the designated position;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Training and re-training;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Authorization of personnel;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Monitoring of competency of personnel.",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddPersonnelManagement = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null)

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  // --- Prefill answers if editing ---
  useEffect(() => {
    const fetchQuestionnaire = async () => {
      if (!questionnaireId) return; // new form
      try {
        setLoading(true);
        const response = await fetch(
          `${env.kataApiUrl}/api/certification/id/${questionnaireId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to load questionnaire");
        }

        const data = await response.json();

        console.log("DATATAA", data)

        setStatus(data.status)

        const prefilled = {};
        if (data.answers && Array.isArray(data.answers)) {
          data.answers.forEach((ans) => {
            prefilled[ans.questionNumber] = {
              score: ans.score,
              comment: ans.comment,
              points: ans.points,
            };
          });
        }

        setAnswers(prefilled);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestionnaire();
  }, [questionnaireId, token]);

  const handleAnswerChange = (questionNumber, score, comment, points) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionNumber]: {
        score,
        comment,
        points: points ? Number(points) : undefined,
      },
    }));
  };

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  const submitAssessment = async () => {
    const answersArray = Object.entries(answers).map(
      ([questionNumber, data]) => ({
        questionNumber,
        score: data.score,
        comment: data.comment,
        points: data.points,
      })
    );

    const payload = {
      name: "SLIPTA",
      labId,
      section: "Personnel Management",
      auditorId: user.id,
      answers: answersArray,
    };

    const url = questionnaireId
      ? `${env.kataApiUrl}/api/certification/id/${questionnaireId}` // edit
      : `${env.kataApiUrl}/api/certification/submit`; // create

    const method = questionnaireId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Submission failed");
    }

    return await response.json();
  };

  const handleDone = async () => {
    try {
      if (Object.keys(answers).length === 0) {
        toast.warning("Please answer at least one question before submitting");
        return;
      }

      await submitAssessment();

      toast.success(
        questionnaireId
          ? "updated successfully!"
          : "Submitted successfully!"
      );

      navigate(-1);
    } catch (error) {
      toast.error(error.message || "Failed to submit assessment");
    }
  };

  return (
    <div className={`${classes.wrapper} ${
        !editable ? classes.fromParams : ""
      }`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 03: Personnel Management {questionnaireId && "(Editing)"}
          {/* ✅ show edit mode */}
        </h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(handleAnswerChange, answers, editable)}

          {editable && <CommonFooter
            handlePrevious={handlePrevious}
            handleCancel={() => navigate(-1)}
            handleNext={handleNext}
            handleDone={handleDone}
            questionSets={questionSets}
            currentSet={currentSet}
            cancelText="Cancel"
            doneText={
              questionnaireId ? "Update Assessment" : "Submit Assessment"
            }
          />}
        </>
      )}
    </div>
  );
};

export default AddPersonnelManagement;
